module.exports = {"start":"开始","restart":"重新开始","testing":"测试 #{test}","download":"下载","upload":"上载","latency":"时延","jitter":"抖动","poweredBy":"提供者","mbps":"兆比特/秒","kbps":"千比特/秒","ms":"毫秒","s":"秒","internetPerformanceTest":"互联网性能测试","yourIp":"你的互联网地址","testServerLocation":"测试服务器位置","referenceNumber":"参考编号","startTest":"开始测试","initialising":"初始化 #{test}","initiateFail":"发生了问题，请再试"}


//////////////////
// WEBPACK FOOTER
// ./src/js/i18n/zh-CN.json
// module id = 205
// module chunks = 0